import React from 'react'
import PassResetForm from 'molecules/PassResetForm'
import AuthHeader from 'molecules/AuthHeader'
import { FormContainer } from './styles'

const PassResetFormTitled = props => (
  <FormContainer>
    <AuthHeader title={props.title} size={'l'} />
    <PassResetForm {...props} />
  </FormContainer>
)

export default PassResetFormTitled

